import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import errorCode from '@/utils/errorCode'
import {getToken, removeToken} from '@/utils/auth'

// 创建axios的对象
const instance = axios.create({
	 // baseURL: "http://124.71.219.226:7710/dev-api/", // 测试环境
	// baseURL: "http://127.0.0.1:7710/dev-api/",  //
	 baseURL: "https://www.zhsh10000.com/dev-api/", // 生产环境
	// baseURL: "http://127.0.0.1:9528/dev-api/",  // 本地后端环境
	timeout: 20000
})

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(
	function(config) {
		config.headers['Custom-Authorization'] = 'Bearer ' + getToken() // 请求头添加token值
		return config
	},
	function(err) {
		return Promise.request(err)
	}
)

// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(res => {
	// 未设置状态码则默认成功状态
	const code = res.data.code || 200;
	// 获取错误信息
	const msg = errorCode[code] || res.data.msg || errorCode['default']
	//if (code === 401) {  // 随便改了一个值，暂时让他不要影响系统 ，后续考虑要不要改
	if (code === 101) {  // 随便改了一个值，暂时让他不要影响系统 ，后续考虑要不要改
		// 当报错401时，保险起见，先将数据存储的数据删除了，不管有没有,省的一直弹出需要登录
		localStorage.removeItem("user")
		removeToken()
		MessageBox.alert('系统未登录，请重新登录', '提示', {
			confirmButtonText: '确定',
			type: 'error'
		}).then(() => {
			store.dispatch("setShowLogin", true);
		})
		return Promise.reject('error')
	} else if (code === 500) {
		Message({
			message: msg,
			type: 'error'
		})
		return Promise.reject(new Error(msg))
	} else if (res.errno === 502) {
		MessageBox.alert('网络异常，请刷新后重试', '提示', {
			confirmButtonText: '确定',
			type: 'error'
		})
		return Promise.reject('error')
	} else {
		return res.data
	}
})

// 封装get和post请求
export function get(url, params) {
	return instance.get(url, {
		params
	})
}

export function post(url, data) {
	return instance.post(url, data)
}

export default instance;
